// extracted by mini-css-extract-plugin
export default {"fruitBox":"Fruit_fruitBox__FXrqL"};